// Fragment "learnQuiz": strings of the shared quiz player (components/learn/QuizView.jsx,
// used by the course player).
// Merged in ./index.js.
export default {
  fr: {
    "quizView.submitFailed": "Vos réponses n'ont pas pu être envoyées. Réessayez dans un instant.",
    "quizView.attemptsExhausted": "Plus aucune tentative disponible.",
    "quizView.attemptsLeft.one": "1 tentative restante",
    "quizView.attemptsLeft.many": "{n} tentatives restantes",
  },
  en: {
    "quizView.submitFailed": "Your answers could not be sent. Please try again in a moment.",
    "quizView.attemptsExhausted": "No attempts left.",
    "quizView.attemptsLeft.one": "1 attempt left",
    "quizView.attemptsLeft.many": "{n} attempts left",
  },
  es: {
    "quizView.submitFailed": "No se pudieron enviar tus respuestas. Vuelve a intentarlo en un momento.",
    "quizView.attemptsExhausted": "No quedan intentos.",
    "quizView.attemptsLeft.one": "Queda 1 intento",
    "quizView.attemptsLeft.many": "Quedan {n} intentos",
  },
};
